(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  var LOCAL_STORAGE_KEY = 'recently_viewed_products_handles';
  var MAX_PRODUCTS_TO_STORE = 3;

  // 1. Record current product handle
  var currentProductHandle = document.querySelector('.recently-viewed-products')?.dataset?.currentProductHandle;

  if (currentProductHandle) {
    try {
      var storedHandles = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '[]');

      // Remove current product handle if already in array
      storedHandles = storedHandles.filter(function(h) {
        return h !== currentProductHandle;
      });

      // Add current product handle to start of list
      storedHandles.unshift(currentProductHandle);

      if (storedHandles.length > MAX_PRODUCTS_TO_STORE) {
        storedHandles = storedHandles.slice(0, MAX_PRODUCTS_TO_STORE);
      }

      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storedHandles));
    } catch (e) {
      console.error("Recently Viewed: Could not save handle to localStorage", e);
    }
  }

  // 2. Load Recently Viewed section content
  var loadRecentlyViewed = function() {
    if (window.Shopify && window.Shopify.designMode) { return; }

    var sectionContainer = document.querySelector(".recently-viewed-products");
    if (!sectionContainer) { return; }

    var storedHandles = [];
    try {
      storedHandles = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '[]');
    } catch (e) {
      return;
    }

    // Filter out current product page
    if (currentProductHandle) {
      storedHandles = storedHandles.filter(function(h) {
        return h !== currentProductHandle;
      });
    }

    if (storedHandles.length === 0) { return; }

    var limit = parseInt(sectionContainer.dataset.limit || 4, 10);
    var handlesToFetch = storedHandles.slice(0, limit);

    // Fetch section HTML rendered using Shopify Section Rendering API via Section URL
    var sectionId = sectionContainer.dataset.sectionId;
    var fetchPromises = handlesToFetch.map(function(handle) {
      return fetch('/products/' + handle + '?section_id=' + sectionId)
        .then(function(res) {
          if (res.ok) return res.text();
          return null;
        })
        .catch(function() { return null; });
    });

    Promise.all(fetchPromises).then(function(htmlResults) {
      var targetList = sectionContainer.querySelector(".product-list");
      if (!targetList) return;

      var validCardHtml = [];

      htmlResults.forEach(function(html) {
        if (!html) return;
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        var productCard = tempDiv.querySelector(".product-block");
        if (productCard) {
          validCardHtml.push(productCard.outerHTML);
        }
      });

      if (validCardHtml.length > 0) {
        targetList.innerHTML = validCardHtml.join('');
        sectionContainer.style.display = "block";

        if (window.theme && window.theme.ProductBlockManager) {
          window.theme.ProductBlockManager.loadImages(sectionContainer);
        }
        if (window.theme && window.theme.initAnimateOnScroll) {
          window.theme.initAnimateOnScroll();
        }
      }
    });
  };

  // Run on DOM load
  if (document.readyState === "complete" || document.readyState === "interactive") {
    loadRecentlyViewed();
  } else {
    document.addEventListener("DOMContentLoaded", loadRecentlyViewed);
  }

  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === document.querySelector('.recently-viewed-products')?.dataset?.sectionId) {
      loadRecentlyViewed();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
